




















import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import Input from '@/components/inputs/Input.vue'
import Modal from '@/components/Modal.vue'
import { ChainModule } from '@/store/modules/chain.module'
import { EAdminTaskStatus, EOnboardingMilestoneStatus, IAdminTask, IOnboardingMilestone, IOnboardingMilestoneTemplate } from '@zunta/configurations'
import { UserModule } from '@/store/modules/user.module'

@Component({
  props: {
    type: {
      type: String,
      default: 'chain'
    },
    task: {
      required: true,
      type: Object
    }
  },
  components: {
    Modal,
    Input
  }
})
export default class CompleteTaskModal extends Vue {
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store);
  userModuleInstance: UserModule = getModule(UserModule, this.$store);
  note: string = '';
  isValidationEnabled: boolean = false;
  isSubmiting: boolean = false
  validate () {
    return !!this.note
  }

  get chain () {
    if (this.$props.type === 'user') {
      return this.user.chain
    }
    return this.$store.state.chain.chain
  }

  get user () {
    return this.$store.state.user.selectedUser
  }

  get tasks () {
    return this.$store.state.chain.adminTasks.filter((adminTask: IAdminTask) => adminTask.status === EAdminTaskStatus.TODO)
  }

  get onboardingData () {
    return this.$store.state.chain.onboardingData
  }

  get milestoneName () {
    if (this.$props.task.trainingMilestone) {
      return this.$props.task.trainingMilestone.template.milestone
    } else if (this.$props.task.onboardingMilestone) {
      return this.$props.task.onboardingMilestone.template.milestone
    } else if (this.$props.task.category) {
      return this.$props.task.category
    } else {
      return 'Task'
    }
  }

  async submit () {
    this.isValidationEnabled = true
    if (this.validate()) {
      this.isSubmiting = true
      await this.chainModuleInstance.changeAdminTaskStatus({
        id: this.$props.task.id,
        data: {
          status: EAdminTaskStatus.COMPLETE,
          note: this.note,
          chainUserId: this.$props.type === 'user' ? this.user.id : null,
          chainId: this.$props.type === 'user' ? null : this.chain.id,
          page: this.$props.type
        }
      })

      if (this.$props.type === 'user') {
        await this.chainModuleInstance.fetchUserAdminTasks(this.user.id)
      } else {
        await this.chainModuleInstance.fetchAdminTasks(this.chain.id)
      }
      this.isSubmiting = false
      this.$emit('close')
    }
  }
}
